export { default as ServiceFaq } from './ServiceFaq/ServiceFaq';
export { default as InfoTable } from './InfoTable/InfoTable';
